module.exports = __webpack_public_path__ + "static/media/tractor.d16a1203.svg";